module.exports = __webpack_public_path__ + "img/legal-expenses.e37c5696.png";